import { Injectable, inject } from '@angular/core';
import { ConsumerPortalApiService } from './consumer-portal-api.service';
import { NotificationService } from './notification.service';
import { tap, catchError } from 'rxjs/operators';
import { of } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';
import { LoggerService } from './logger.service';
import { Searchable } from '../models/searchable.model';
import { OrgDetail } from '../models/organization-detail.model';

type OrgDetailSearchable = Searchable & OrgDetail;

@Injectable({
    providedIn: 'root'
})
export class OrganizationIdService {
    private readonly notification = inject(NotificationService);
    private readonly consumerPortalApiService = inject(ConsumerPortalApiService);
    private readonly logger = inject(LoggerService);

    getOrgIdFromUrl(url: string) {
        if (url.length) {
            return this.consumerPortalApiService.get<OrgDetailSearchable>(`public/organizations/url?url=${url}`).pipe(
                tap({
                    next: (data: OrgDetail[]) => {
                        // Successfully found organization - domain is taken
                        return data;
                    }
                }),
                catchError((error: HttpErrorResponse) => {
                    if (error.status === 400 || error.status === 404) {
                        // 400/400 means domain is available/not found - this is expected behavior
                        return of(false);
                    } else {
                        // Other errors are unexpected
                        this.logger.logInfo('Something went wrong when requesting getOrgIdFromUrl');
                        this.logger.logError(error?.error?.message);
                        this.logger.alertDevError(error);
                        if (error?.error?.message) {
                            alert(error.error.message);
                        }
                        return of(false);
                    }
                })
            );
        } else {
            this.notification.error('Invalid Sub Domain URL');
            return of(false);
        }
    }
}
